import axios from "axios";

const API_BASE = `${process.env.REACT_APP_API_BASE_URL}/api/v1/ratings`;

// Create or update a rating
export const createOrUpdateRating = async (ratingDTO) => {
  const response = await axios.post(API_BASE, ratingDTO);
  return response.data;
};

// Get rating by providerId & patientId
export const getRating = async (providerId, patientId) => {
  const response = await axios.get(API_BASE, {
    params: { providerId, patientId },
  });
  return response.data;
};

// Delete rating by ratingId
export const deleteRatingById = async (ratingId) => {
  const response = await axios.delete(`${API_BASE}/${ratingId}`);
  return response.data;
};

// Delete rating by providerId & patientId
export const deleteRatingByProviderAndPatient = async (
  providerId,
  patientId,
) => {
  const response = await axios.delete(
    `${API_BASE}/provider/${providerId}/patient/${patientId}`,
  );
  return response.data;
};

// Get all reviews + avg rating + count for a provider
export const getProviderRatings = async (providerId) => {
  const response = await axios.get(`${API_BASE}/provider/${providerId}`);
  return response.data;
};

// Get average rating only
export const getAverageRating = async (providerId) => {
  const response = await axios.get(`${API_BASE}/average`, {
    params: { providerId },
  });
  return response.data;
};
